<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
    >
        <path
            d="M10.25 11C10.25 11.4141 10.5859 11.75 11 11.75C11.4141 11.75 11.75 11.4141 11.75 11V9.5C11.75 9.0859 11.4141 8.75 11 8.75C10.5859 8.75 10.25 9.0859 10.25 9.5V11Z"
            fill="currentColor"
        />
        <path
            d="M4.5 11.75C4.0859 11.75 3.75 11.4141 3.75 11V7C3.75 6.5859 4.0859 6.25 4.5 6.25C4.9141 6.25 5.25 6.5859 5.25 7V11C5.25 11.4141 4.9141 11.75 4.5 11.75Z"
            fill="currentColor"
        />
        <path
            d="M7 11C7 11.4141 7.3359 11.75 7.75 11.75C8.1641 11.75 8.5 11.4141 8.5 11V4.5C8.5 4.0859 8.1641 3.75 7.75 3.75C7.3359 3.75 7 4.0859 7 4.5V11Z"
            fill="currentColor"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.75 0C1.67893 0 0 1.67893 0 3.75V11.75C0 13.8211 1.67893 15.5 3.75 15.5H11.75C13.8211 15.5 15.5 13.8211 15.5 11.75V3.75C15.5 1.67893 13.8211 0 11.75 0H3.75ZM1.5 3.75C1.5 2.50736 2.50736 1.5 3.75 1.5H11.75C12.9926 1.5 14 2.50736 14 3.75V11.75C14 12.9926 12.9926 14 11.75 14H3.75C2.50736 14 1.5 12.9926 1.5 11.75V3.75Z"
            fill="currentColor"
        />
    </svg>
</template>
